import api from '../../../../api';

export interface ScorableItem {
  id: string;
  name: string;
  type: 'medialink' | 'user-material';
  module: string;
  node: LiteralString<'general'>;
  isAssignment: boolean;
  isFreeExercise: boolean;
  contentType?: {
    id: string;
    name: string;
    category: string;
    iconClassName?: string;
    icon?: string;
    imagePreview: boolean;
    isExercise: boolean;
    printable: boolean;
  };
  isAdaptive: boolean;
  showPoints: boolean;
  exerciseCategories?: string[];
  assignmentRanges: { from: string; to: string }[];
}

export async function fetchScorableItems(moduleId: string, schoolYearId: string, includeSubmodules = false) {
  const {
    data: { data: scorableItems },
  } = await api.get<{ data: ScorableItem[] }>(
    `/studio/modules/${moduleId}/results/${schoolYearId}/scorable-items?includeSubmodules=${includeSubmodules}`,
  );

  return scorableItems;
}
